import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { NavLink } from 'react-router-dom';
import { translateStaticContent } from '../../../helpers/translateStaticContent';

class Nav extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showMenu: false,
        }
    }

    handleClick = () => {
        this.setState({...this.state, showMenu: !this.state.showMenu})
    }

    render() {
        const isShowMenu = this.state.showMenu ? 'show' : 'hide';
        return (
            <nav className="nav">
                <input type='checkbox' id="menu" value={this.state.showMenu} onClick={this.handleClick}/>
                <label htmlFor='menu' className='nav-menu'><span className='icon-burger'></span></label>
                <div className={`${isShowMenu} menu`}>
                    <div className="dropdown">
                        <label htmlFor='inner-menu' className='nav-inner-menu'>
                            {translateStaticContent('transfers',
                                this.props.defaultStaticContent, this.props.activeLangStaticContent)}
                            <span className="down"></span>
                        </label>
                        <div className="inner-menu">
                            <NavLink to={{
                                pathname: '/transferState',
                                hash: '#transferState',
                                state: {
                                    getTransferInfo: false
                                }
                            }} onClick={this.handleClick} rel="noreferrer">
                                {translateStaticContent('transferInfo',
                                    this.props.defaultStaticContent, this.props.activeLangStaticContent)}
                            </NavLink>
                            <NavLink to={{
                                pathname: '/transferState',
                                hash: '#getTransferInfo',
                                state: {
                                    getTransferInfo: true
                                }
                            }} onClick={this.handleClick} rel="noreferrer">
                                {translateStaticContent('transferState',
                                    this.props.defaultStaticContent, this.props.activeLangStaticContent)}
                            </NavLink>
                            <NavLink to={{
                                pathname: '/calculator',
                                hash: '#howToSend',
                                state: {
                                    howToSend: true
                                }
                            }} onClick={this.handleClick} rel="noreferrer">
                                {translateStaticContent('transferSend',
                                    this.props.defaultStaticContent, this.props.activeLangStaticContent)}
                            </NavLink>
                            <NavLink to={{
                                pathname: '/calculator',
                                hash: '#calculate',
                                state: {
                                    howToSend: false
                                }
                            }} onClick={this.handleClick} rel="noreferrer">
                                {translateStaticContent('transferCount',
                                    this.props.defaultStaticContent, this.props.activeLangStaticContent)}
                            </NavLink>
                        </div>
                    </div>
                    <div>
                        <NavLink to='/tariffs' className='link' onClick={this.handleClick} rel="noreferrer">
                            {translateStaticContent('tariffs',
                                this.props.defaultStaticContent, this.props.activeLangStaticContent)}
                        </NavLink>
                    </div>
                    <div>
                        <NavLink to='/maps' className='link' onClick={this.handleClick} rel="noreferrer">
                            {translateStaticContent('points',
                                this.props.defaultStaticContent, this.props.activeLangStaticContent)}
                        </NavLink>
                    </div>
                    <div>
                        <NavLink to='/faqs' className='link' onClick={this.handleClick} rel="noreferrer">
                            {translateStaticContent('faqs',
                                this.props.defaultStaticContent, this.props.activeLangStaticContent)}
                        </NavLink>
                    </div>
                    <div>
                        <NavLink to='/news' className='link' onClick={this.handleClick} rel="noreferrer">
                            {translateStaticContent('news',
                                this.props.defaultStaticContent, this.props.activeLangStaticContent)}
                        </NavLink>
                    </div>
                    <div>
                        <NavLink to='/aboutSystem' className='link' onClick={this.handleClick} rel="noreferrer">
                            {translateStaticContent('aboutSystem',
                                this.props.defaultStaticContent, this.props.activeLangStaticContent)}
                        </NavLink>
                    </div>
                </div>
            </nav>
        )
    }

}

export default Nav;

Nav.propTypes = {
    defaultStaticContent: PropTypes.object,
    activeLangStaticContent: PropTypes.object
}